export const iconFontAwesomeScienceAtom = (
	<i className="fa-solid fa-atom"></i>
);
